import React, {createContext, useContext, useEffect, useState} from "react";
import { FilterOption } from "../types/filterTypes";
import {SearchOptions} from "../types/mamTypes";

export interface ActiveFilters {
    textSearch?: string
    contentTypeFilterValues?: FilterOption[],
    periodFilterValues?: FilterOption[],
    keyMomentTypeValues?: FilterOption[],
    jobFilterValues?: FilterOption[],
    jobExtractionSchedule?: ['string' | null, 'string' | null],
    aspectRatioFilterValues?: FilterOption[],
    matchFilterValues?: FilterOption[],
    competitionFilterValues?: FilterOption[],
    eventDate?: ['string' | null, 'string' | null],
    productionDate?: ['string' | null, 'string' | null],
    lastTypeModified?: string;
    tags?: FilterOption[],
    ratingFilter?: FilterOption[],
    fastClipFilter?: boolean
}
// Definizione del tipo per il contesto
interface ActiveFiltersContextType {
    activeFilters: ActiveFilters;
    setActiveFilters: (activeFilters: ActiveFilters) => void;
    searchOptions: SearchOptions | undefined;
    setSearchOption: (fieldName: keyof SearchOptions, value: string) => void;
}

// Creazione del contesto
const ActiveFiltersContext = createContext<ActiveFiltersContextType | undefined>(undefined);
const dateFilters = ['jobExtractionSchedule']
// Provider del contesto
export const ActiveFiltersProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [activeFilters, setActiveFilters] = useState<ActiveFilters>({});
    const [searchOptions, setSearchOptions] = useState<SearchOptions>();

    function setSearchOption(fieldName: keyof SearchOptions, value: string){
        const tempSearchOptions = {...searchOptions};
        tempSearchOptions[fieldName] = value
        setSearchOptions(tempSearchOptions);
    }

    return (
        <ActiveFiltersContext.Provider value={{activeFilters, setActiveFilters, setSearchOption, searchOptions }}>
            {children}
        </ActiveFiltersContext.Provider>
    );
};

// Custom Hook per usare il contesto
export const useActiveFilters = () => {
    const context = useContext(ActiveFiltersContext);
    if (!context) {
        throw new Error("useActiveFilters deve essere usato dentro ActiveFiltersProvider");
    }
    return context;
};
